export function toggleVisibility(idArray, toggledId) {

    if (idArray.includes(toggledId)) {

        return idArray.filter(id => id !== toggledId);

    } else {

        return [...idArray, toggledId];
    }
}